import React, { useState } from 'react'
import { ChevronDown, ChevronRight } from 'react-bootstrap-icons'
import AccountCell from './AccountCell'
import StatusBadge from './StatusBadge'
import { PROCESSED_COLUMNS, exactTime, relativeTime, reportTypeLabel } from './waitingListConstants'

export default function ProcessedRow({ row, onNavigate }) {
  const [expanded, setExpanded] = useState(false)
  const isExpandable = row.status === 'failed' && Boolean(row.error_message)

  const toggle = () => {
    if (isExpandable) setExpanded(!expanded)
  }

  return (
    <div className="border-b-1 border-rb-widget-border dark:border-rb-dark-mode-lighter last:border-b-0">
      <div
        role="button"
        tabIndex={isExpandable ? 0 : -1}
        onClick={toggle}
        onKeyDown={e => {
          if (isExpandable && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault()
            toggle()
          }
        }}
        className={`flex items-center gap-4 px-4 py-2 transition-colors hover:bg-rb-grey dark:hover:bg-rb-dark-mode-lighter ${isExpandable ? 'cursor-pointer' : 'cursor-default'}`}
      >
        <span className={`${PROCESSED_COLUMNS.chevron} text-rb-mat-grey dark:text-rb-dark-mode-text-grey`}>
          {isExpandable && (expanded ? <ChevronDown className="text-[10px]" /> : <ChevronRight className="text-[10px]" />)}
        </span>
        <AccountCell
          row={row}
          className={PROCESSED_COLUMNS.account}
          onNavigate={e => {
            e.stopPropagation()
            onNavigate()
          }}
        />
        <span className={`${PROCESSED_COLUMNS.email} text-sm text-rb-mat-grey dark:text-rb-dark-mode-text-grey truncate`} title={row.email || ''}>
          {row.email || '–'}
        </span>
        <span className={`${PROCESSED_COLUMNS.type} text-sm text-rb-black dark:text-white truncate`}>
          {reportTypeLabel(row)}
        </span>
        <span className={`${PROCESSED_COLUMNS.requestedBy} text-sm text-rb-mat-grey dark:text-rb-dark-mode-text-grey truncate`}>
          {row.requested_by || 'System'}
        </span>
        <span className={`${PROCESSED_COLUMNS.finished} text-sm text-rb-mat-grey dark:text-rb-dark-mode-text-grey truncate`} title={exactTime(row.finished_at)}>
          {relativeTime(row.finished_at)}
        </span>
        <span className={PROCESSED_COLUMNS.status}>
          <StatusBadge status={row.status} />
        </span>
      </div>

      {expanded && isExpandable && (
        <div className="px-4 pb-3 pl-[2.625rem] space-y-1 text-xs">
          <p className="text-rb-mat-grey dark:text-rb-dark-mode-text-grey">
            Gave up after {row.attempts} {row.attempts === 1 ? 'attempt' : 'attempts'} · queued {exactTime(row.queued_at)} · failed {exactTime(row.finished_at)}
          </p>
          <p className="font-mono break-all text-red-700 dark:text-red-300">{row.error_message}</p>
          <p className="text-rb-mat-grey dark:text-rb-dark-mode-text-grey">
            Pull the account from Modash again to retry.
          </p>
        </div>
      )}
    </div>
  )
}
